import { NgModule } from '@angular/core';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';

import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  HomeOutline,
  CheckSquareOutline,
  ClockCircleOutline,
  ContactsOutline,
  CalendarOutline,
  AuditOutline,
  ScheduleOutline,
  FolderOutline,
  MenuOutline,
  UserOutline,
  PlusOutline,
  CarOutline,
  FileAddOutline,
  ProfileOutline,
  SendOutline,
  HistoryOutline,
  ArrowRightOutline,
  DeleteOutline,
  MailOutline,
  SearchOutline,
  FileProtectOutline,
  DownOutline,
  ReloadOutline,
  FilterOutline,
  FilterFill,
  CopyOutline,
  MoreOutline,
  LinkOutline,
  CheckOutline,
  BarChartOutline,
} from '@ant-design/icons-angular/icons';

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  HomeOutline,
  CheckSquareOutline,
  ClockCircleOutline,
  ContactsOutline,
  CalendarOutline,
  AuditOutline,
  ScheduleOutline,
  FolderOutline,
  MenuOutline,
  UserOutline,
  PlusOutline,
  CarOutline,
  FileAddOutline,
  ProfileOutline,
  SendOutline,
  HistoryOutline,
  ArrowRightOutline,
  DeleteOutline,
  MailOutline,
  SearchOutline,
  FileProtectOutline,
  DownOutline,
  ReloadOutline,
  FilterOutline,
  FilterFill,
  CopyOutline,
  MoreOutline,
  LinkOutline,
  CheckOutline,
  BarChartOutline,
];

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [{ provide: NZ_ICONS, useValue: icons }],
})
export class IconsProviderModule {}
